import React from 'react';
import { SearchIcon, ClipboardListIcon, WindIcon, ShieldCheckIcon, ArrowLeftIcon } from 'lucide-react';
export function SolutionSteps() {
  const steps = [{
    number: '1',
    title: 'בדיקה ואבחון',
    desc: 'מגיעים תוך שעה, בודקים את מקור הרטיבות עם מצלמות תרמיות וציוד מתקדם לאיתור נזילות.',
    icon: SearchIcon
  }, {
    number: '2',
    title: 'תכנית טיפול',
    desc: 'מציגים פתרון מותאם אישית עם מחיר שקוף, ידוע מראש וללא הפתעות.',
    icon: ClipboardListIcon
  }, {
    number: '3',
    title: 'ייבוש מקצועי',
    desc: 'מפעילים יבשנים תעשייתיים וטכנולוגיית ייבוש תת-רצפתי – תוצאות תוך 24-48 שעות.',
    icon: WindIcon
  }, {
    number: '4',
    title: 'אחריות ומעקב',
    desc: 'מבצעים בדיקת לחות סופית, מפיקים דוח לחברת הביטוח ומעניקים אחריות בכתב.',
    icon: ShieldCheckIcon
  }];
  return <section className="py-20 bg-[#f5f5f7] px-4 md:px-8" data-id="element-136">
      <div className="max-w-7xl mx-auto" data-id="element-137">
        <div className="text-center mb-16" data-id="element-138">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-139">
            איך אנחנו עובדים?
          </h2>
          <p className="text-xl text-gray-600" data-id="element-140">
            תהליך מקצועי, מהיר ושקוף ב-4 שלבים פשוטים
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16 relative" data-id="element-141">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-12 right-0 left-0 h-1 bg-gray-200 -z-10 transform -translate-y-1/2 w-[80%] mx-auto" data-id="element-142"></div>

          {steps.map((step, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-all relative group" data-id="element-143">
              <div className="w-16 h-16 bg-[#f97316] text-white rounded-full flex items-center justify-center text-2xl font-bold mb-6 mx-auto shadow-lg shadow-orange-200 group-hover:scale-110 transition-transform" data-id="element-144">
                {step.number}
              </div>
              <div className="text-center" data-id="element-145">
                <step.icon className="w-10 h-10 text-gray-400 mx-auto mb-4" data-id="element-146" />
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-147">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-148">{step.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="text-center flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-149">
          <a href="tel:0523552222" className="inline-flex items-center gap-2 bg-[#f97316] hover:bg-orange-600 text-white px-10 py-5 text-xl font-bold rounded-full shadow-lg transition-all transform hover:scale-105" data-id="element-150">
            התחילו עכשיו – 052-355-2222
          </a>
          <a href="tel:0545188888" className="inline-flex items-center gap-2 bg-[#f97316] hover:bg-orange-600 text-white px-10 py-5 text-xl font-bold rounded-full shadow-lg transition-all transform hover:scale-105" data-id="element-151">
            או חייגו – 054-518-8888
          </a>
        </div>
      </div>
    </section>;
}